import React from "react";
import { faPen, IconDefinition } from "@fortawesome/free-solid-svg-icons";

import ToggleableButton from "components/ToggleableButton";
import ModalConfirm from "components/ModalConfirm";
import { ModalConfirmProps } from "components/ModalConfirm/ModalConfirm";

export interface EditButtonRenderProps {
	isUnlocked: boolean;
	onClick: (e: MouseEvent) => void;
}

interface ModalFieldProps {
	isUnlocked?: boolean;
	editButton?: (props: EditButtonRenderProps) => React.ReactNode;
	toggleIsOpen: (e: unknown) => void;
	displayValue: string;
	isOpen: boolean;
	handleOK: () => void;
	handleCancel: () => void;
	title: string;
	allowWrapInButton?: boolean;
	helptext?: string;
	editIcon?: IconDefinition;
	useTertiaryButton?: boolean;
	useTallButton?: boolean;
	onContents?: ModalConfirmProps["onContents"];
}

const ModalField: React.FunctionComponent<ModalFieldProps> = ({
	isUnlocked = true,
	editButton,
	toggleIsOpen,
	displayValue,
	isOpen,
	handleOK,
	handleCancel,
	title,
	allowWrapInButton = false,
	helptext,
	editIcon = faPen,
	useTertiaryButton = false,
	useTallButton = false,
	onContents,
	children
}) => {
	return (
		<>
			{editButton ? (
				editButton({ isUnlocked, onClick: toggleIsOpen })
			) : (
				<ToggleableButton
					isEditing={isUnlocked}
					icon={editIcon}
					onClick={toggleIsOpen}
					label={displayValue}
					allowWrap={allowWrapInButton}
					isTertiary={useTertiaryButton}
					isTall={useTallButton}
				/>
			)}

			<ModalConfirm
				isOpen={isOpen}
				onOK={handleOK}
				onCancel={handleCancel}
				title={title}
				size="big"
				helptext={helptext}
				onContents={onContents}
			>
				{children}
			</ModalConfirm>
		</>
	);
};

export default ModalField;
